/*
  Simplified BSD License (see LICENSES/BSD-2-Clause.txt or https://opensource.org/licenses/BSD-2-Clause)
  SPDX-FileCopyrightText: Ansible Project
  SPDX-License-Identifier: BSD-2-Clause
*/
export var PartType;
(function (PartType) {
    PartType[PartType["ERROR"] = 0] = "ERROR";
    PartType[PartType["BOLD"] = 1] = "BOLD";
    PartType[PartType["CODE"] = 2] = "CODE";
    PartType[PartType["HORIZONTAL_LINE"] = 3] = "HORIZONTAL_LINE";
    PartType[PartType["ITALIC"] = 4] = "ITALIC";
    PartType[PartType["LINK"] = 5] = "LINK";
    PartType[PartType["MODULE"] = 6] = "MODULE";
    PartType[PartType["RST_REF"] = 7] = "RST_REF";
    PartType[PartType["URL"] = 8] = "URL";
    PartType[PartType["TEXT"] = 9] = "TEXT";
    PartType[PartType["ENV_VARIABLE"] = 10] = "ENV_VARIABLE";
    PartType[PartType["OPTION_NAME"] = 11] = "OPTION_NAME";
    PartType[PartType["OPTION_VALUE"] = 12] = "OPTION_VALUE";
    PartType[PartType["PLUGIN"] = 13] = "PLUGIN";
    PartType[PartType["RETURN_VALUE"] = 14] = "RETURN_VALUE";
})(PartType || (PartType = {}));
//# sourceMappingURL=dom.js.map